import { Close } from "components/icons";
import { useState } from "react";

// custom multi input text field

const MultiInputField = ({ selectedOptions, setSelectedOptions, placeholder }) => {
  const [value, setValue] = useState("");
  const handleRemove = (event, index) => {
    setSelectedOptions([...selectedOptions.slice(0, index), ...selectedOptions.slice(index + 1)]);
  };
  const handleValueChange = (event) => {
    setValue(event.target.value);
  };
  return (
    <div className="position-relative mt-3">
      <div className="media-live-input-tags-container form-control" trigger="click">
        <ul class="filter-tags-list">
          {selectedOptions.map((option, index) => {
            return (
              <li>
                {option}
                <button
                  type="button"
                  class="btn btn-filter-remove"
                  onClick={(event) => {
                    handleRemove(event, index);
                  }}
                >
                  <Close />
                </button>
              </li>
            );
          })}
        </ul>

        <input
          type="text"
          className="input-tags-container-input"
          value={value}
          placeholder={!selectedOptions.length ? placeholder : ""}
          onChange={handleValueChange}
          onKeyDown={(event) => {
            if (event.key === "Backspace" && !value.length) {
              setSelectedOptions([...selectedOptions.slice(0, selectedOptions.length - 1)]);
            }
            if (event.key === "Enter") {
              event.preventDefault();
              if (value.length) {
                setSelectedOptions([...selectedOptions, event.target.value.trim()]);
                setValue("");
              }

              event.target.focus();
            }
          }}
        />
      </div>
    </div>
  );
};
export default MultiInputField;
